import { getSystemName } from '@/shared/utils/global';
import { useMemo } from 'react';
export const useSystemName = (authLoginType) => {
    const hostname = window.location.hostname;
    const systemName = useMemo(() => {
        const { cnName } = getSystemName(authLoginType);
        return cnName;
    }, [hostname]);
    return systemName;
};
